import validator from "validator";
import message from "../../messages/user";
import mobileValidator from "../mobile";

const validateFirstName = (firstname) => {
  if (validator.isEmpty(firstname)) {
    return message.FIRSTNAME_DOSE_NOT_EXIST;
  }

  if (!firstname.trim().length) {
    return message.FIRSTNAME_IS_WRONG;
  }

  return true;
};

const validateLastName = (lastName) => {
  if (validator.isEmpty(lastName)) {
    return message.LASTNAME_DOSE_NOT_EXIST;
  }

  if (!lastName.trim().length) {
    return message.LASTNAME_IS_WRONG;
  }

  return true;
};

const validateCategoryId = (categoryId) => {
  if (validator.isEmpty(categoryId)) {
    return message.CATEGORY_USER_ID_DOSE_NOT_EXIST;
  }

  if (!categoryId.trim().length) {
    return message.CATEGORY_USER_ID_DOSE_NOT_EXIST;
  }

  if (categoryId == null) {
    return message.CATEGORY_USER_ID_IS_WRONG;
  }

  if (categoryId == 0) {
    return message.CATEGORY_USER_ID_IS_WRONG;
  }

  if (!validator.isNumeric(categoryId)) {
    return message.CATEGORY_USER_ID_IS_WRONG;
  }

  return true;
};

const validatePhone = (phone) => {
  if (validator.isEmpty(phone)) {
    // return message.PHONE_DOSE_NOT_EXIST;
    return true;
  }

  if (!validator.isNumeric(phone)) {
    return message.PHONE_IS_WRONG;
  }

  return true;
};

const validateNationalCode = (nationalCode) => {
  if (validator.isEmpty(nationalCode)) {
    // return message.NATIONAL_CODE_DOSE_NOT_EXIST;
    return true;
  }

  if (!validator.isNumeric(nationalCode)) {
    return message.NATIONAL_CODE_IS_WRONG;
  }

  return true;
};

const validateIdentityNumber = (identityNumber) => {
  if (validator.isEmpty(identityNumber)) {
    // return message.IDENTITY_CODE_DOSE_NOT_EXIST;
    return true;
  }

  if (!validator.isNumeric(identityNumber)) {
    return message.IDENTITY_CODE_IS_WRONG;
  }

  return true;
};

const validateState = (state) => {
  if (validator.isEmpty(state)) {
    // return message.STATE_DOSE_NOT_EXIST;
    return true;
  }

  if (!state.trim().length) {
    return message.STATE_IS_WRONG;
  }
  return true;
};
const validateCity = (city) => {
  if (validator.isEmpty(city)) {
    // return message.CITY_DOSE_NOT_EXIST;
    return true;
  }

  if (!city.trim().length) {
    return message.CITY_IS_WRONG;
  }
  return true;
};

const validateTown = (town) => {
  if (validator.isEmpty(town)) {
    // return message.TOWN_DOSE_NOT_EXIST;
    return true;
  }
  if (!town.trim().length) {
    return message.TOWN_IS_WRONG;
  }
  return true;
};

const validatePostalCode = (postalCode) => {
  if (validator.isEmpty(postalCode)) {
    // return message.POSTAL_CODE_DOSE_NOT_EXIST;
    return true;
  }

  if (!validator.isNumeric(postalCode)) {
    return message.POSTAL_CODE_IS_WRONG;
  }
  return true;
};

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobileValidator.isNumericMobile(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  if (!mobileValidator.validMobileNumber(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  return true;
};

const validateFormInfoUser = (info) => {
  const resValidateFirstName = validateFirstName(info.firstname);
  if (resValidateFirstName != true) {
    return resValidateFirstName;
  }

  const resValidateCategoryId = validateCategoryId(info.category_id);
  if (resValidateCategoryId != true) {
    return resValidateCategoryId;
  }

  /*
  const resValidateLastName = validateLastName(info.lastname);
  if (resValidateLastName != true) {
    return resValidateLastName;
  }

  
  const resValidatePhone = validatePhone(info.phone);
  if (resValidatePhone != true) {
    return resValidatePhone;
  }

  const resNationalCode = validateNationalCode(info.national_code);
  if (resNationalCode != true) {
    return resNationalCode;
  }

  const resIdentityNumber = validateIdentityNumber(info.identity_number);
  if (resIdentityNumber != true) {
    return resIdentityNumber;
  }

  const resValidateState = validateState(info.state);
  if (resValidateState != true) {
    return resValidateState;
  }

  const resValidateCity = validateCity(info.city);
  if (resValidateCity != true) {
    return resValidateCity;
  }

  const resValidateTown = validateTown(info.town);
  if (resValidateTown != true) {
    return resValidateTown;
  }

  const resValidatePostalCode = validatePostalCode(info.postal_code);
  if (resValidatePostalCode != true) {
    return resValidatePostalCode;
  }
  */

  return true;
};

export default {
  validateMobile,
  validateFormInfoUser,
};
